import addStaticMembersTo
import buildValues
import dev.shanty.kotwire.stimulus.Application
import dev.shanty.kotwire.stimulus.Event
import kotlin.Array
import kotlin.Boolean
import kotlin.String
import kotlin.js.JsExport
import kotlin.reflect.KClass
import org.w3c.dom.HTMLElement

@JsExport
public interface TripSearchControllerTargetLifecycleHooks {
  public fun inputTargetConnected(element: HTMLElement) {
  }

  public fun inputTargetDisconnected(element: HTMLElement) {
  }

  public fun resultsTargetConnected(element: HTMLElement) {
  }

  public fun resultsTargetDisconnected(element: HTMLElement) {
  }

  public fun backdropTargetConnected(element: HTMLElement) {
  }

  public fun backdropTargetDisconnected(element: HTMLElement) {
  }

  public fun iconTargetConnected(element: HTMLElement) {
  }

  public fun iconTargetDisconnected(element: HTMLElement) {
  }

  public fun spinnerTargetConnected(element: HTMLElement) {
  }

  public fun spinnerTargetDisconnected(element: HTMLElement) {
  }

  public fun searchUrlValueChanged(`value`: String, previousValue: String) {
  }
}

public fun <T : HTMLElement> TripSearchController.inputTarget(): StimulusProperty<T> =
    StimulusProperty("inputTarget")

public fun <T : HTMLElement> TripSearchController.inputTargets(): StimulusProperty<Array<T>> =
    StimulusProperty("inputTargets")

public fun <T : HTMLElement> TripSearchController.resultsTarget(): StimulusProperty<T> =
    StimulusProperty("resultsTarget")

public fun <T : HTMLElement> TripSearchController.resultsTargets(): StimulusProperty<Array<T>> =
    StimulusProperty("resultsTargets")

public fun <T : HTMLElement> TripSearchController.backdropTarget(): StimulusProperty<T> =
    StimulusProperty("backdropTarget")

public fun <T : HTMLElement> TripSearchController.backdropTargets(): StimulusProperty<Array<T>> =
    StimulusProperty("backdropTargets")

public fun <T : HTMLElement> TripSearchController.iconTarget(): StimulusProperty<T> =
    StimulusProperty("iconTarget")

public fun <T : HTMLElement> TripSearchController.iconTargets(): StimulusProperty<Array<T>> =
    StimulusProperty("iconTargets")

public fun <T : HTMLElement> TripSearchController.spinnerTarget(): StimulusProperty<T> =
    StimulusProperty("spinnerTarget")

public fun <T : HTMLElement> TripSearchController.spinnerTargets(): StimulusProperty<Array<T>> =
    StimulusProperty("spinnerTargets")

public fun TripSearchController.searchUrlValue(): StimulusProperty<String> =
    StimulusProperty("searchUrlValue")

public fun TripSearchController.hasSearchUrlValue(): Boolean {
  println(this.asDynamic()["hasSearchUrlValue"])
  return this.asDynamic()["hasSearchUrlValue"]
}

public fun registerTripSearchController(stimulus: Application) {
               val clazz = TripSearchController::class
               val properties = object  {
                  // Js name needed otherwise Kotlin will mangle the name
                  @JsName("targets")
                  val targets = js("""[
  "input",
  "results",
  "backdrop",
  "icon",
  "spinner",
  ]""")

                  @JsName("values")
                  val values = buildValues(
                      setOf(
                          ValueDefinition("searchUrl", "String", false)
                      ),
                      TripSearchController.Values
                  )
                  
                  
                  
                  @JsName("classes")
                  val classes = js("[]")
              }

              val factoryFunc = clazz.js.asDynamic()

              addStaticMembersTo(factoryFunc, properties)
              val controllerName = "tripsearch"
              println("Registering controller tripsearch")

              stimulus.register(controllerName, factoryFunc)
}
